import React, {useEffect, useState} from 'react'
import {inject, observer} from 'mobx-react'
import {PauseOutlined, CaretRightOutlined} from '@ant-design/icons'
import Button from '@components/button'
import MonitorItem from '@components/monitorItem'
import cs from 'classnames'
import AddProgram from './add-program'
import {getMediaWallProgram, getMonitorList, playMediaWallProgram} from '@apis'
import './index.less'

function repairNum(num) {
  if (num < 10) {
    return `0${num}`
  }
  return num
}

// 灯光秀控制
const CockpitLightControl = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {brokerId} = userInfo

    const [pgList, setPgList] = useState([])
    const [monitorList, setMonitorList] = useState([])
    const [currentPlayPgIndex, setCurrentPlayPgIndex] = useState(null)
    const [currentPlayVideoIndex, setCurrentPlayVideoIndex] = useState(null)
    const [addProgramVisible, setAddProgramVisible] = useState(false)
    const [pauseVideo, setPauseVideo] = useState()
    const [videoObj, setVideoObj] = useState()
    const [isPlay, setIsPlay] = useState()

    // 查询节目列表
    async function getProgramList() {
      const params = {
        pageNo: 1,
        pageSize: 9999,
        brokerId,
      }
      const res = await getMediaWallProgram(params)
      if (res.data) {
        setPgList(res.data.map(item => {
          let videoList = []
          item.programBillMediaWallInstanceDTOList.forEach(one => {
            videoList = videoList.concat(one.videoInstanceDTOList)
          })
          const result = {
            ...item,
            videoList
          }
          return result
        }))
        for(let i=0; i<res.data.length; i++) {
          if(res.data[i].playStatus == 1) {
            setVideoObj(res.data[i])
            setCurrentPlayPgIndex(i)
          }
        }
      }
    }

    async function queryMonitorList() {
      const params = {
        brokerId,
        pageNo: 1,
        pageSize: 9999,
      }
      const res = await getMonitorList(params)
      if (res && res.data) {
        setMonitorList(res.data)
      }
    }

    async function playpro(record, playStatus) {
      const params = {
        programId: record.id,
        playStatus,
        programType: 1
      }
      const res = await playMediaWallProgram(params)
      console.log(res)
    }

    // 双击某个节目开始播放
    function startPlayPg(pgIndex, res) {
      const pgObj = pgList[pgIndex]
      setCurrentPlayPgIndex(pgIndex)
      setVideoObj(res)
      setIsPlay(0)
      if (pgObj.videoList && pgObj.videoList.length) {
        setCurrentPlayVideoIndex(0)
      }
    }

    function pausePlatPg(item) {
      if(isPlay == 0) {
        if(document.getElementById('video')) {
          document.getElementById('video').pause()
        }
        playpro(item, 0)
        setIsPlay(1)
      } else {
        setIsPlay(0)
        if(document.getElementById('video')) {
          document.getElementById('video').play()
        }
        playpro(item, 1)
      }
    }

    useEffect(() => {
      if (!addProgramVisible) {
        getProgramList()
      }
      queryMonitorList()
    }, [addProgramVisible])

    return (
      <React.Fragment>
        <div className="light-show-left">
          {
            videoObj ? videoObj.bindSpecialSource === null ? null : ((videoObj.bindSpecialSource.split('http')[0] == "" ? (
              <video
                autoPlay
                muted
                loop
                src={videoObj.bindSpecialSource}
                className="light-video"
                id="video"
              />
            ) : (
              monitorList.length ? (
                <MonitorItem
                  url={videoObj.bindSpecialSource}
                  accessToken={monitorList[0].monitorAccessToken}
                />
              ) : null)
            )) : null
          }
        </div>
        <div className="light-show-right">
          <div className={cs({
            "program-box": true,
            hidden: addProgramVisible,
          })}>
            <Button
              onClick={() => {
                setAddProgramVisible(true)
              }}
            >
              编辑节目
            </Button>
            <div className="program-list clearfix">
              {/* <div className="program-item-box">
                <div className="program-item active">
                  <div className="pg-active-con">
                    <div className="pg-active-title">
                      01/
                    </div>
                    <div className="pg-active-name">
                      夕阳红
                    </div>
                    <div className="pg-active-desc">
                      当前选择播放
                    </div>
                  </div>
                  <div className="line-top"/>
                  <div className="line-left"/>
                  <div className="line-right"/>
                  <div className="line-bottom"/>
                </div>
              </div> */}
              {
                pgList.filter(one => one.dataBigscreenDisplay === 1).map((item, index) => (
                  <div
                    className="program-item-box"
                    onClick={() => {
                      if (index === currentPlayPgIndex) return pausePlatPg(item)
                      startPlayPg(index, item)
                      playpro(item, 1)
                    }}
                  >
                    {
                      index === currentPlayPgIndex ? (
                        <div className="program-item active">
                          <div className="pg-active-con" style={{position:'absolute', bottom:'10px', width: '100%', textAlign: 'center'}}>
                            {isPlay? <CaretRightOutlined /> : <PauseOutlined/>}
                            <div className="pg-active-title">
                              {repairNum(index + 1)}/ {videoObj.name}
                            </div>
                            {/* <div className="pg-active-name">
                            </div> */}
                            <div className="pg-active-desc">
                              当前选择播放
                            </div>
                          </div>
                          <div className="line-top"/>
                          <div className="line-left"/>
                          <div className="line-right"/>
                          <div className="line-bottom"/>
                        </div>
                      ) : (
                        <div className="program-item">
                          <img src={item.coverBannerUrl} className="pg-banner" />
                          <div className="program-title">
                            {repairNum(index + 1)}/ {item.name}
                          </div>
                        </div>
                      )
                    }
                  </div>
                ))
              }
            </div>
          </div>
          <AddProgram
            visible={addProgramVisible}
            switchVisible={setAddProgramVisible}
            pgList={pgList}
          />
        </div>
      </React.Fragment>
    )
  })
)

export default CockpitLightControl